import React,{useState} from 'react';
import css from './index.css';
import {Container,Button,TextField,CircularProgress} from '@material-ui/core';

export default function Contact() {


const [email,setemail]=useState('');
const [question,setquestion]=useState('');
const [message,setmessage]=useState('');
const [texterror,settexterror]=useState('');
const [color,setcolor]=useState('white');
const [loading,setloading]=useState(false);

const senddata=(e)=>{
  setloading(true);
e.preventDefault();
fetch('https://apimessagestomail.herokuapp.com/messages',{
  method:"POST",
  body:JSON.stringify({
      email : email,
      question: question,
      message : message
  })
})
.then(response=>response.json())
.then(data=>
{
  console.log(data);
   if(data.status=="OK"){
     setcolor('green');
     settexterror('I got your message , I will reply sooon , thanks.')
     setloading(false);
   }else{
      setcolor('red');
      settexterror("Error : Something happen please , try again or later.")
      setloading(false);
   }
}
);
}

  return (
    <div className="contactform">
    <Container maxWidth="sm" >
   <form id='form' onSubmit={senddata}>
   <p style={{ color:color }}>{texterror}</p>
   <TextField onChange={(e)=>setemail(e.target.value)} name="email" id="outlined-basic" label="Email"/>
   <TextField onChange={(e)=>setquestion(e.target.value)} name="question" id="outlined-basic" label="Subject"/>
   <TextField onChange={(e)=>setmessage(e.target.value)} name="message" id="outlined-basic" label="Message" multiline rows={5}/>
   <br/>
   {loading ? <div className="progress"><CircularProgress /></div>
   : 
    <Button type="submit" variant="contained" color="primary">Send</Button>
   }
    </form> 
    </Container>
    </div>
  );
}
